<script setup lang="ts">
import { getIcon, type IconName } from '@/components/icons'

type Props = {
  icon: IconName
}
const props = defineProps<Props>()
</script>

<template>
  <component :is="getIcon(props.icon)" />
</template>

<style scoped></style>
